import React from "react";
import "./Shop_specialty_business.css";
import CommonHeadingBeforeAfterLine from "../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine";
import Shop_specialty_business_cards from "../../Common-Component/Shop_specialty_business_cards/Shop_specialty_business_cards";

function Shop_specialty_business({productdata}) {
  const cardsArray = Array(6).fill(null); // Creates an array with 5 elements

  return (
    <section className="Shop_specialty_business">
      <div className="custom_container">
        <CommonHeadingBeforeAfterLine headingText={"Shop specialty business cards"} />

        <div className="Shop_specialty_business_cards_holder">
          <div className="row">
          {productdata.map((val, index) => (
              <div key={index} className="col-lg-4 col-md-4 col-sm-6 col-6 mb-3">
                <Shop_specialty_business_cards val={val}/>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Shop_specialty_business;
